<span nz-space nzAlign="start">
  <button *nzSpaceItem nz-button nzType="text" (click)="redirectToHistory()">
    <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
  </button>
</span>
<nz-tabset>
  <nz-tab nzTitle="Results" *ngIf="authService.hasEntitlements(viewQueryResult)">
    <nz-card>
      <app-list-query-result [queryRecord]="queryRecord" *ngIf="queryRecord?.type === 'LIST'"></app-list-query-result>
      <app-aggregate-query-result
        [queryRecord]="queryRecord"
        *ngIf="queryRecord?.type === 'AGGREGATE'"
      ></app-aggregate-query-result>
    </nz-card>
  </nz-tab>
</nz-tabset>
